import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, updateProfile, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// LIVE project. Used by the deployed site, `npm run build`, `npm run preview` and `npm run dev:live`.
const liveConfig = {
  apiKey: "AIzaSyDDfZGneTi8hGDULI2-HXRiQjntZH_xrrw",
  authDomain: "turbo-erp-3dd21.firebaseapp.com",
  projectId: "turbo-erp-3dd21",
  storageBucket: "turbo-erp-3dd21.firebasestorage.app",
  messagingSenderId: "788081495732",
  appId: "1:788081495732:web:507c7c85846b70c53e11e1",
  measurementId: "G-VR1ZG9R164"
};

// TEST project for the local Firebase emulators (fake data, see docs/how-to-run.md).
// A "demo-" project ID can never reach real Firebase servers.
const EMULATOR_PROJECT_ID = "demo-turbo-erp";
const emulatorConfig = {
  apiKey: "demo-api-key",
  authDomain: `${EMULATOR_PROJECT_ID}.firebaseapp.com`,
  projectId: EMULATOR_PROJECT_ID,
  storageBucket: `${EMULATOR_PROJECT_ID}.appspot.com`,
  appId: "demo-app-id"
};

// Which one to use:
// - `npm run dev` (dev server)        -> emulator (TEST MODE). Safe default.
// - `npm run dev:live` (--mode live)  -> live, with a warning.
// - any build (deployed site, preview) -> live, exactly as before.
const isDevServer = import.meta.env.DEV;
const wantsLive = import.meta.env.MODE === "live";
const onLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);

if (isDevServer && !wantsLive && !onLocalhost) {
  // Never fall back to live silently (e.g. dev server opened from a phone on the network).
  throw new Error("TEST MODE only works on http://localhost. Open the app on localhost, or use `npm run dev:live` on purpose.");
}

export const isEmulator = isDevServer && !wantsLive;
export const isLocalLive = isDevServer && wantsLive;

// Initialize Firebase
const app = initializeApp(isEmulator ? emulatorConfig : liveConfig);

// Initialize Firebase Auth
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Storage
const storage = getStorage(app);

// Cloud Functions (same region as the deployed functions). getFunctions(app, region)
// returns this same instance everywhere in the app, so the emulator link below applies to all calls.
const functions = getFunctions(app, "asia-south1");

if (isEmulator) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectStorageEmulator(storage, "127.0.0.1", 9199);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  console.info("TEST MODE: connected to local Firebase emulators (fake data).");
} else if (isLocalLive) {
  console.warn("LIVE DATA: this local app is connected to the LIVE Firebase project turbo-erp-3dd21. Look only - do not save, approve, block, delete or merge.");
}

export { app, auth, googleProvider, db, storage, functions, updateProfile };
